function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import { ensureMap } from '../hocs/ensureMap';

var MapEvent = function (_React$Component) {
  _inherits(MapEvent, _React$Component);

  function MapEvent() {
    var _temp, _this, _ret;

    _classCallCheck(this, MapEvent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (evt) {
      if (_this.props.onMapClick) _this.props.onMapClick(evt);
    }, _this.handleSingleClick = function (evt) {
      if (_this.props.onMapSingleClick) _this.props.onMapSingleClick(evt);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MapEvent.prototype.componentDidMount = function componentDidMount() {
    var map = this.props.map;

    map.on('click', this.handleClick);
    map.on('singleclick', this.handleSingleClick);
  };

  MapEvent.prototype.componentWillUnmount = function componentWillUnmount() {
    var map = this.props.map;

    map.un('click', this.handleClick);
    map.un('singleclick', this.handleSingleClick);
  };

  MapEvent.prototype.render = function render() {
    return null;
  };

  return MapEvent;
}(React.Component);

MapEvent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A function that takes an module:ol/MapBrowserEvent and returns a {boolean}.
   *
   * @param {ol/MapBrowserEvent} event Event from ol/Map click event.
   * @returns {boolean} if the event is a click event
   */
  onMapClick: PropTypes.func,
  /**
   * A function that takes an module:ol/MapBrowserEvent and returns a {boolean}.
   *
   * @param {ol/MapBrowserEvent} event Event from ol/Map singleclick event.
   * @returns {boolean} if the event is a map singleclick event
   */
  onMapSingleClick: PropTypes.func,
  /**
   * @ignore
   */
  map: PropTypes.object
} : {};


export default ensureMap(MapEvent);